/**
 * パスワード変更
 */
export class ChangePassword {
    /** 旧パスワード */
    oldPassword = ""
    /** 新パスワード１ */
    newPassword1 = ""
    /** 新パスワード２ */
    newPassword2 = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<ChangePassword>) {
        Object.assign(this, init)
    }
}
